import React from "react";
import CustomModal from "../../common/CustomModal";
import { Button } from "../../ui/button";
import { MdOutlineCloudUpload } from "react-icons/md";
import { RiAdvertisementLine } from "react-icons/ri";

const NewDeliveryChoiceModal = ({ open, onClose, onUploadExcel, onSingleEntry }) => {
  return (
    <CustomModal open={open} title="New delivery" onClose={onClose} isButtonsRequired={false}>
      <div className="flex flex-col gap-3 py-2 items-stretch">
        <Button
          variant="outline"
          className="w-full justify-start h-12 text-left shrink-0"
          onClick={() => {
            onClose();
            onUploadExcel?.();
          }}
        >
          <MdOutlineCloudUpload className="w-5 h-5 mr-3 shrink-0" />
          Create bulk deliveries
        </Button>
        <Button
          variant="outline"
          className="w-full justify-start h-12 text-left shrink-0"
          onClick={() => {
            onClose();
            onSingleEntry?.();
          }}
        >
          <RiAdvertisementLine className="w-5 h-5 mr-3 shrink-0" />
          Single ad delivery
        </Button>
      </div>
    </CustomModal>
  );
};

export default NewDeliveryChoiceModal;
